import { render } from "./UserSwitch.vue?vue&type=template&id=ad590bf8&ts=true"
import script from "./UserSwitch.vue?vue&type=script&lang=ts"
export * from "./UserSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__